import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=ff5c9f54&scoped=true&"
import script from "./emptyLayout.vue?vue&type=script&lang=js&"
export * from "./emptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./emptyLayout.vue?vue&type=style&index=0&id=ff5c9f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5c9f54",
  null
  
)

export default component.exports